
export const GET_REGISTER_MOBILE_REQUEST = 'GET_REGISTER_MOBILE_REQUEST';
export const GET_REGISTER_MOBILE_SUCCESS = 'GET_REGISTER_MOBILE_SUCCESS';
export const GET_REGISTER_MOBILE_FAILURE = 'GET_REGISTER_MOBILE_FAILURE';
export const AUTH_ERROR_REQUEST = "AUTH_ERROR_REQUEST";
export const GET_SIGNUP_OTP_REQUEST = "GET_SIGNUP_OTP_REQUEST";
export const GET_SIGNUP_OTP_FAILURE = "GET_SIGNUP_OTP_FAILURE";
export const GET_OTP_REQUEST = "GET_OTP_REQUEST";
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";
export const LOGIN_WITH_OTP_SUCCESS = "LOGIN_WITH_OTP_SUCCESS"
export const GET_OTP_FAILURE = "GET_OTP_FAILURE";
export const LOGIN_WITH_OTP_FAILURE = "LOGIN_WITH_OTP_FAILURE";
export const LOGIN_WITH_OTP_REQUEST = "LOGIN_WITH_OTP_REQUEST";
export const GET_RESEND_OTP_REQUEST = "GET_RESEND_OTP_REQUEST";
export const RESET_REDUX_STORE_REQUEST = 'RESET_REDUX_STORE_REQUEST';
export const SIGN_OUT_REQUEST = "SIGN_OUT_REQUEST";
export const SIGN_OUT_FAILURE = "SIGN_OUT_FAILURE";
export const RESET_AUTH_STORE_REQUEST = "RESET_AUTH_STORE_REQUEST";
export const RESET_AUTH_STORE_SUCCESS = "RESET_AUTH_STORE_SUCCESS";
export const SET_TAB_SERVICE = "SET_TAB_SERVICE";